import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'toInteger'
})
export class ToIntegerPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
